import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-recuperar-password',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './recuperar-password.component.html',
  styleUrl: './recuperar-password.component.css',
  standalone: true
})
export class RecuperarPasswordComponent {
form: FormGroup;
  loading = false;
  mensaje = '';
  error = '';

  constructor(private fb: FormBuilder, private authService: AuthService,    private router: Router
) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  recuperar() {
    if (this.form.invalid) return;

    this.loading = true;
    this.error = '';
    this.mensaje = '';

    this.authService.recuperarPassword(this.form.value.email).subscribe({
      next: () => {
        this.mensaje = 'Si existe una cuenta con ese email, se enviaron las instrucciones.';
        this.loading = false;
        alert(this.mensaje);
        this.router.navigate(['/login']);
      },
      error: () => {
        this.error = 'Ocurrió un error al procesar la solicitud.';
        this.loading = false;
      }
    });
  }
  volverLogin() {
    this.router.navigate(['/login']);
  }
}
